import { api, setConfig } from '../..';
import { mapEntityToApi, mapApiToEntity } from './mapper';
import { PropertyType } from '../../../common';

export const getTransactions = (data: PropertyType): Promise<PropertyType> =>
	api.post(`players/transactions${data?.query}`, mapEntityToApi(data), setConfig(data)).then((res) => {
		return mapApiToEntity(res.data);
	});

export const getTransactionsExport = (data: PropertyType): Promise<PropertyType> =>
	api.post(`export/transactions${data?.query}`, { sid: data.token }, setConfig(data)).then((res) => {
		return mapApiToEntity(res.data);
	});
